var path = 'rulechain/rulechain-card.tpl.html';
var html = " <div ng-if=\"item && item.root\" translate>rulechain.root</div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/rulechain/rulechain-card.tpl.html
// module id = 1510
// module chunks = 1